import {ACTIONS} from '../actions/Actions'
import {find_evaluation, evaluation} from '../config/evaluations'


const companies = (state = {selected: []}, action) => {

  switch  (action.type){
    case ACTIONS.companies.search.statuses.completed: {
	    return Object.assign({}, state, {search_result: {status: 'COMPLETED', result: action.data}})
    }
    case ACTIONS.companies.search.statuses.requested: {
	    return Object.assign({}, state, {search_result: {status: 'REQUESTED', result: null}})
    }
    case ACTIONS.companies.search.statuses.error: {
	    return Object.assign({}, state, {search_result: {status: 'ERROR', result: null}})
    }
    case ACTIONS.companies.analysis.statuses.requested: {
	    return Object.assign({}, state, { analysis: undefined})
    }
    case ACTIONS.companies.index.statuses.completed: {     
	    return Object.assign({}, state, { index: action.data})
    }
    case ACTIONS.companies.analysis.statuses.completed: {
	    return Object.assign({}, state, { analysis: action.data})
    }
    case ACTIONS.companies.score_distribution.statuses.completed: {
	    return Object.assign({}, state, { score_distribution: action.data})
    }
    case ACTIONS.companies.expositions_scores.statuses.completed: {
	    const expositions_scores = action.data != null ? (evaluation.map(e => {	      
	      let exp = action.data.filter(es => es.final_more_score == e.score)[0]	      
	      return ({
		      category: e.letter,
		      value1: exp != null ? Math.round(parseFloat(exp.leftover-exp.leftover_expired)) : 0,
		      count1: exp != null ? exp.number_of_companies-exp.number_of_expired_companies : 0,
		      value2: exp != null ? Math.round(parseFloat(exp.leftover_expired)) : 0,
		      count2: exp != null ? exp.number_of_expired_companies : 0,
	      })})) : null	    
	    return Object.assign({}, state, { expositions_scores:  expositions_scores})
    }
    case ACTIONS.companies.show().statuses.completed: {
	    return Object.assign({}, state, {opened: action.data})
    }
    case ACTIONS.reports.create().statuses.completed: {
	    const reports = Object.assign([], [action.data].concat(state.opened.reports) )
	    return Object.assign({}, state, {opened: {...state.opened, ...{reports: reports}}})
    }
    case ACTIONS.reports.update().statuses.completed: {
	    const replaceIndex = state.opened.reports.findIndex(r => r.id===action.data.id);	
	    return Object.assign({}, state, {opened: {...state.opened, ...{reports: state.opened.reports.map((item, index) => index === replaceIndex ? action.data : item)}}})
    }	    
    case ACTIONS.companies.select: {	    
	    let selected = []
	    var index = state.selected.findIndex(c => c.id === action.id)
	    if(action.id === false)
	      selected = state.index.companies_ids	
	    else if(action.id === true)
	      selected = []
	    else if(index >= 0){
	      let issuing_companies = state.selected[index].issuing_companies
	      if(action.issuing_companies == null)
		      issuing_companies = []
	      else if(action.issuing_companies.every(ic => state.selected[index].issuing_companies.includes(ic)))
		      issuing_companies = issuing_companies.filter(ic => !action.issuing_companies.includes(ic))	    
	      else
		      issuing_companies = issuing_companies.concat(action.issuing_companies)	    
	      selected =  [...state.selected.slice(0,index),
			               (issuing_companies.length > 0 ? {...state.selected[index], ...{issuing_companies: issuing_companies}} : null),
			               ...state.selected.slice(index+1)].filter(x => x)
	    }
	    
	    else
	      selected = [...state.selected, {id: action.id, issuing_companies: action.issuing_companies}]
	    return Object.assign({}, state, {selected: [...selected]})
    }
    case ACTIONS.companies.create.statuses.completed: {
	    let search_result = Object.assign([], state.search_result.result.data, state.search_result.result.data.map(c =>{
	      if(c.identification_number === action.data.identification_number){
		      return Object.assign({}, c, {id: action.data.id})
	      }
	      else
		      return c
	    } ))

	    return Object.assign({}, state, {search_result: {result: {data: search_result}}})
    }
    default:
	    return state
  }
}
export default companies
